import { lazy, Suspense } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AppBootstrap } from '@/components/AppBootstrap';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { Spinner } from '@/components/common/Spinner';
import { AppConfigProvider } from '@/context/AppConfigContext';
import { ResultsProvider } from '@/context/ResultsContext';
import { ScanProvider } from '@/context/ScanContext';
import { UserProvider } from '@/context/UserContext';
import { ROUTES } from '@/utils/constants';

const StartScanPage = lazy(() =>
  import('@/pages/StartScanPage').then((m) => ({ default: m.StartScanPage })),
);
const ScanInstructionsPage = lazy(() =>
  import('@/pages/ScanInstructionsPage').then((m) => ({
    default: m.ScanInstructionsPage,
  })),
);
const UserDetailsPage = lazy(() =>
  import('@/pages/UserDetailsPage').then((m) => ({ default: m.UserDetailsPage })),
);
const ScanPage = lazy(() =>
  import('@/pages/ScanPage').then((m) => ({ default: m.ScanPage })),
);
const ResultsPage = lazy(() =>
  import('@/pages/ResultsPage').then((m) => ({ default: m.ResultsPage })),
);

export function App(): React.ReactElement {
  return (
    <ErrorBoundary>
      <AppConfigProvider>
        <UserProvider>
          <ScanProvider>
            <ResultsProvider>
              <AppBootstrap />
              <BrowserRouter>
                <Suspense fallback={<Spinner fullPage />}>
                  <Routes>
                    <Route path={ROUTES.HOME} element={<StartScanPage />} />
                    <Route path={ROUTES.DETAILS} element={<UserDetailsPage />} />
                    <Route path={ROUTES.INSTRUCTIONS} element={<ScanInstructionsPage />} />
                    <Route path={ROUTES.SCAN} element={<ScanPage />} />
                    <Route path={ROUTES.RESULTS} element={<ResultsPage />} />
                    <Route path="*" element={<Navigate to={ROUTES.HOME} replace />} />
                  </Routes>
                </Suspense>
              </BrowserRouter>
            </ResultsProvider>
          </ScanProvider>
        </UserProvider>
      </AppConfigProvider>
    </ErrorBoundary>
  );
}
